const styles = theme => ({
  titleWrapper: {
    alignItems: 'center',
    display: 'flex',
    marginBottom: theme.spacing.unit * 5
  },
  title: {
    flex: 1
  },
  searchRoot: {
    '& fieldset': {
      border: '0 !important'
    }
  },
  searchIcon: {
    color: 'rgba(12,31,44,0.54)',
    marginLeft: theme.spacing.unit * 0.25
  },
  tableRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(12,31,44, 0.04)'
    }
  },
  hazMatCell: {
    alignItems: 'center',
    display: 'flex'
  },
  tooltip: {
    backgroundColor: '#2A3C47',
    color: '#FFFFFF !important',
    minWidth: 203,
    padding: theme.spacing.unit * 1.5
  },
  tooltipPopper: {
    top: `-${theme.spacing.unit}px !important`
  },
  hazMatInfoButtonRoot: {
    '&:hover': {
      backgroundColor: 'transparent !important'
    }
  }
});

export default styles;
